import React from 'react';
import _ from 'lodash';

import CellContent from './CellContent';
import { getErrorValidateWithId } from '../../../utilities/works';
import { Dropdown } from '../../dropdowns/portal';
import FieldItemService from '../../../services/FieldItems';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import { FIELD_ITEM_LISTS } from '../../../utilities/constants';

const fieldId = SessionStorageService.getFieldId();

const FieldItemBaseTemplate = ({
  msgValidate,
  context,
  grid,
  handlePushParam,
  fieldItemType,
  title,
  numberOfPlace,
  column,
}) => {
  const { isAbortedOrApproved } = context.item;
  const template = FIELD_ITEM_LISTS[fieldItemType];

  const getError = () => {
    return getErrorValidateWithId(
      msgValidate,
      context.item,
      `${fieldItemType}_item_id`
    );
  };

  const handleSetData = data => {
    const { id, name } = data || {};
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem[`${fieldItemType}_item_id`] = id;
    v.currentItem[`${fieldItemType}_item_name`] = name;
    if (!v.currentItem['is_data_changed'][`${fieldItemType}_item_id`]) {
      v.currentItem['is_data_changed'][`${fieldItemType}_item_id`] = true;
    }
    v.commitEdit();
    handlePushParam(context.item);
  };

  const getFieldItems = params => {
    return FieldItemService.list(fieldId, {
      ...params,
      item_list_ids: template.id,
      display_flag: 1,
    });
  };

  const renderDropdownFieldItem = () => {
    const isShowClearButton = !_.includes(
      context.item.required_item_list_ids,
      numberOfPlace
    );
    return (
      <Dropdown
        handleOnChange={handleSetData}
        name={context.item[`${fieldItemType}_item_name`]}
        value={context.item[`${fieldItemType}_item_id`]}
        callbackApi={getFieldItems}
        responseKey={template.entitiesName}
        fieldValue='id'
        fieldName='name'
        label={title}
        key={context.item.id}
        isShowToolTip={true}
      >
        <Dropdown.Select readOnly={isAbortedOrApproved} />
        <Dropdown.List>
          <Dropdown.Search />
          {isShowClearButton && <Dropdown.ClearSelect />}
          <Dropdown.RadioItems />
        </Dropdown.List>
      </Dropdown>
    );
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(
        context,
        `item.is_data_changed[${fieldItemType}_item_id]`
      )}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      {renderDropdownFieldItem()}
    </CellContent>
  );
};

export default FieldItemBaseTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/FieldItemTemplate.jsx